import $ from 'jquery';
import analytics from '../../services/analytics_service';
import config from '../../config';

export default () => {
    if (config.get('featureFlags.piwikEnabled') === true) {
        if (window.location.search !== '') {
            const results = $('.js-search-total').data('total');
            const term = $('.search-input').val();
            if (results && term) {
                analytics.trackSearch(term, results);
            }
        }
    }
};
